
import Component from 'vue-class-component'
import { Prop, Vue, Watch } from 'vue-property-decorator'

/**
 * This component functions as a validation guard to prevent form submission
 * when it is on or active (`isOn` is `true`).
 *
 * It renders a hidden required checkbox input and a <TixMessage> error message.
 * The checkbox serves as an invisible validation hook, allowing the component
 * to participate in form validation via `reportFormValidity()`.
 *
 * The error message is conditionally displayed when:
 *  - the guard is on (`isOn` is `true`)
 *  - checkbox is invalid (`alerted` is `true`),
 *  - and `message` is set,
 *
 * ⚠️ If this component is conditionally rendered (e.g., via v-if)
 * after an asynchronous operation (e.g., a network request),
 * you must take precautions (e.g., disable the submit button while loading)
 * to avoid false positives from the `reportFormValidity()` helper.
 */
@Component({
  name: 'FormValidationGuard',
  components: {},
})
export default class extends Vue {
  @Prop({ default: false })
  isOn: boolean

  @Prop({ required: true })
  message: string | null

  alerted = false

  onInvalid() {
    this.alerted = true
    this.$emit('alert', true)
  }

  @Watch('isOn')
  onGuardChange(isOn: boolean) {
    if (isOn) {
      this.alerted = false
    }
  }

  get showMessage() {
    return this.alerted && this.isOn && this.message
  }
}
